/**
 * typewriterEffect(element)
 *
 * This function takes an HTML element as input and applies a typewriter effect to its text content.
 * It works by:
 * 1. Getting the text content of the element.
 * 2. Clearing the original text content.
 * 3. Creating a <span> element for each character in the text.
 * 4. Setting the opacity of each <span> to 0 (invisible).
 * 5. Appending each <span> to the original element.
 * 6. Gradually increasing the opacity of each <span> to 1 (visible) using an interval,
 *    creating the typewriter effect.
 * 7. Once all characters are visible, clearing the interval and restoring the original text content.
 *
 * @param {HTMLElement} element - The HTML element to apply the typewriter effect to.
 */
export function typewriterEffect(element) {
    // Get the text content of the element
    const text = element.textContent;
    // Clear the original text content
    element.textContent = '';

    // Create a <span> element for each character in the text
    for (let char of text) {
        const span = document.createElement('span');
        span.textContent = char;
        // Set the opacity of each <span> to 0 (invisible)
        span.style.opacity = '0';
        // Append each <span> to the original element
        element.appendChild(span);
    }

    let i = 0;
    // Gradually increase the opacity of each <span> to 1 (visible) using an interval
    const interval = setInterval(() => {
        if (i < element.childNodes.length) {
            element.childNodes[i].style.opacity = '1';
            i++;
        } else {
            // Once all characters are visible, clear the interval and restore the original text content
            clearInterval(interval);
            //element.textContent = text;
        }
    }, 30); // set animation speed in ms
}

export function initTypewriterObserver() {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const element = entry.target.querySelector(
                    '.elementor-heading-title'
                );
                if (
                    element &&
                    !element.classList.contains('typewriter-animated')
                ) {
                    typewriterEffect(element);
                    element.classList.add('typewriter-animated');
                    observer.unobserve(entry.target); // Stop observing after animation
                }
            }
        });
    });

    // Observe elements with the class 'typewriter'
    document.querySelectorAll('.typewriter').forEach((element) => {
        observer.observe(element);
    });
}
